/* One fixed line per screen. Callers do not pass the server body through. */

const SCREEN_MESSAGES = {
  login: "Sign-in failed. Check the email and password, then try again.",
  register: "Could not create the account. Check the details and try again.",
  twofa: "That code was not accepted. Try again.",
  reset: "That reset could not be completed. Try again.",
  admin: "That could not be completed. Try again.",
};

export function screenMessage(screen) {
  return SCREEN_MESSAGES[screen] || SCREEN_MESSAGES.admin;
}
